import React, { useEffect, useState } from "react";
import { NX_TIMER_CONFIG, NX_TIMER_TYPES } from "../../../pages/GamePlay/types";
import { getWidth } from "../../../utils/relativeSizes";
import clsx from "clsx";
import styles from "./styles.module.css";

interface TimerCircularAnimationProps {
  totalTurnTime: number; // Total time for the timer (in seconds)
  timeLeft: number; // Remaining time (in seconds)
  resetTimer: number; // A value to trigger timer reset
  timerType: NX_TIMER_TYPES; // Type of timer (used for configurations)
  percentageToChangeColorFrom?: number; // When to change the timer's stroke color
}


const TIMER_CONFIG: NX_TIMER_CONFIG = {
    [NX_TIMER_TYPES.BANK_SMALL]: {
      strokeLength: 2 * Math.PI * getWidth(13),
      height: getWidth(30),
      width: getWidth(30),
      cx: getWidth(15),
      cy: getWidth(15),
      r: getWidth(13),
      strokeWidth: getWidth(3)
    },
    [NX_TIMER_TYPES.BANK_LARGE]: {
      strokeLength: 2 * Math.PI * getWidth(17),
      height: getWidth(38),
      width: getWidth(38),
      cx: getWidth(19),
      cy: getWidth(19),
      r: getWidth(17),
      strokeWidth: getWidth(3)
    },
    [NX_TIMER_TYPES.TURN]: {
      strokeLength: 2 * Math.PI * getWidth(37),
      height: getWidth(78),
      width: getWidth(78),
      cx: getWidth(39),
      cy: getWidth(39),
      r: getWidth(37),
      strokeWidth: getWidth(4)
    }
  }
  

const TimerCircularAnimation: React.FC<TimerCircularAnimationProps> = ({
  totalTurnTime,
  timeLeft,
  resetTimer,
  timerType,
  percentageToChangeColorFrom = 0.5,
}) => {
  const timerConfig = TIMER_CONFIG[timerType] || TIMER_CONFIG.TURN;
  const [progress, setProgress] = useState(0); // Track progress (0 to 1)
  const [strokeColor, setStrokeColor] = useState("#64DCA2"); // Initial stroke color

  useEffect(() => {
    let animationFrame: number;
    const startTime = performance.now();

    // Update timer progress
    const animate = (currentTime: number) => {
      const elapsedTime = (currentTime - startTime) / 1000; // Time in seconds
      const newProgress = Math.min(elapsedTime / timeLeft, 1); // Cap progress at 1

      setProgress(newProgress);

      // Change color based on progress
      if (newProgress >= percentageToChangeColorFrom) {
        setStrokeColor("#F85D79");
      }

      if (newProgress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrame); // Cleanup animation frame
    };
  }, [timeLeft, resetTimer, percentageToChangeColorFrom]);

  // Calculate stroke offset based on progress
  const strokeOffset = timerConfig.strokeLength * (1 - progress);

  return (
    <svg
    className={clsx(styles.diceCircle)}
      height={timerConfig.height}
      width={timerConfig.width}
      style={{
        position: "absolute",
        transform: "rotate(-90deg)"
      }}
    >
      <circle
        fill="transparent"
        cx={timerConfig.cx}
        cy={timerConfig.cy}
        r={timerConfig.r}
        strokeWidth={timerConfig.strokeWidth}
        stroke="#e6e6e6"
      />
      <circle
        fill="transparent"
        cx={timerConfig.cx}
        cy={timerConfig.cy}
        r={timerConfig.r}
        strokeWidth={timerConfig.strokeWidth}
        stroke={strokeColor}
        strokeDasharray={timerConfig.strokeLength}
        strokeDashoffset={strokeOffset}
        // style={{ transition: "stroke-dashoffset 0.1s linear, stroke 0.3s ease" }}
      />
    </svg>
  );
};

export default TimerCircularAnimation;
